import { cn } from '@tripleten/cn';

export const cnLoginOtp = cn('login-otp');
